<template> 
  <div class="route-thumbnail">
    <div class="flex flex-sb-c">
      <router-link :to="`/r/${route.id}`" class="fill flex flex-sb-c">  
        <div class="route-thumbnail-icon">
          <AppIcon :name="$t('vehicles.icons.' + route.settings.vehicle)" />
        </div>
        <div class="fill">
          <div class="flex flex-f-c">
            <h3>{{ route.settings.name }} <span class="text-tag text-smaller bg-error" v-if="route.live">LIVE</span> </h3>
            <AppIcon :name="route.settings.private ? 'https' : 'public'" 
                      style="margin-left:.25rem;opacity:0.75;font-size:1.125rem"
                      v-tooltip="route.settings.private ? 'Privat' : 'Offentlig'" />
          </div>
          <div class="route-thumbnail-summary">{{ route.places?.length || 0 }} stop <span>|</span> {{ $filters.distance(route.distance) }} <span>|</span> {{ $filters.duration(route.duration) }}</div>
        </div>
      </router-link>
      <AppButton v-if="mode === 'delete'" @click="confirmDelete = true" icon="delete" class="color-error">{{ $t('route.delete') }}</AppButton>
      <AppDropdown v-else>
        <AppButton v-if="route.live" @click="endLive()" icon="do_not_disturb_on" class="color-error">{{ $t('live.end_live') }}</AppButton>
        <AppButton @click="$router.push(`/r/${route.id}`)" icon="launch">{{ $t('route.open') }}</AppButton>
        <AppButton @click="share()" icon="share">{{ $t('route.share') }}</AppButton>
        <AppButton @click="copyRouteLink()" icon="copy">{{ $t('route.copy_link') }}</AppButton>
        <AppButton v-if="!route.live" class="PLUS" @click="goLive()" icon="play_arrow">{{ $t('live.go_live') }}</AppButton>
        <AppButton @click="confirmDelete = true" icon="delete" class="color-error">{{ $t('route.delete') }}</AppButton>
      </AppDropdown>
    </div>
    <Confirm v-model="confirmDelete" @confirm="remove()" @cancel="confirmDelete = false" :desc="$t('route.confirm_delete_desc', {name: route.settings.name})" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import AppDropdown from '@/components/atoms/AppDropdown.vue'
import Confirm from '@/components/modals/Confirm.vue'

import { copyToClipboard } from '../../api/tools'
import { store } from '@/store'

import { Route } from '@/api/tripply/models'
import { getRouteLink } from '@/api/tripply'

export default defineComponent({
  name: 'RouteThumbnail',
  components: { AppDropdown, Confirm },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    mode: String as PropType<'delete'>
  },
  setup(props) {
    const showShareRoute = ref(false)
    const confirmDelete = ref(false)

    function remove() {
      store.route.deleteRoute(props.route.id)
    }
    function copyRouteLink() {
      copyToClipboard(getRouteLink(props.route.id, true))
    }
    function share() {
      store.route.share(props.route.id)
    }
    function goLive() {
      store.route.goLive(props.route.id)
    }
    function endLive() {
      store.route.endLive(props.route.id)
    }

    return { confirmDelete, remove, showShareRoute, copyRouteLink, share, goLive, endLive }
  }
})
</script>

<style lang="scss" scoped>
.route-thumbnail {
  transition: all .2s;
  padding: 1rem 0;
  border-top: 1px solid var(--color-divider);
  margin-bottom: 0;

  &-icon {
    border-radius: 1rem;
    background: var(--text-color-tertiary);
    color: var(--text-color-secondary);
    height: 3rem;
    flex: 3rem 0 0;  
    margin-right: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-summary {
    color: var(--text-color-secondary);
    span {
      color: var(--text-color-tertiary);
      margin: 0 .25rem;
    }
  }
  .live {
    color: var(--color-error);
    transform: scale(0.75);
    display: inline-block;
  }
  a {
    text-decoration: none;
    color: inherit;
  }

  h3 {
    margin: 0;
  }

  &:hover {

  }
}  
</style>